import { render } from "./ModeratorPage.vue?vue&type=template&id=458022cc&scoped=true"
import script from "./ModeratorPage.vue?vue&type=script&lang=js"
export * from "./ModeratorPage.vue?vue&type=script&lang=js"

import "./ModeratorPage.vue?vue&type=style&index=0&id=458022cc&scoped=true&lang=css"
import "./ModeratorPage.vue?vue&type=style&index=1&id=458022cc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-458022cc"]])

export default __exports__